(function(){
  var t=document.getElementById('navToggle'),l=document.getElementById('navLinks');
  if(t&&l){t.addEventListener('click',function(){l.classList.toggle('open');});
    l.addEventListener('click',function(e){if(e.target.tagName==='A')l.classList.remove('open');});}
  var bar=document.getElementById('stickyBuy');
  if(bar){window.addEventListener('scroll',function(){bar.classList.toggle('show',window.scrollY>680);},{passive:true});}
  window.setMain=function(src,el){var m=document.getElementById('heroImg');if(m)m.src=src;
    document.querySelectorAll('.thumbs img').forEach(function(x){x.classList.remove('active');});if(el)el.classList.add('active');};
  document.querySelectorAll('.qty button').forEach(function(b){b.addEventListener('click',function(){
    var i=document.getElementById('qty');if(!i)return;var v=parseInt(i.value||'1',10)+parseInt(b.getAttribute('data-step'),10);
    i.value=Math.max(1,isNaN(v)?1:v);});});
})();
